import { getFullName } from './getFullName';

import { IJoinRequestsUserResponse } from 'services';
import { IJoinRequestsUser } from 'views/pages/JoinRequests/join-requests.interface';

function convertToJoinRequestsTable(
  accounts: IJoinRequestsUserResponse[],
): IJoinRequestsUser[] {
  return accounts.map(({ id, firstName, lastName, email }) => ({
    fullName: getFullName(firstName, lastName),
    email,
    id,
  }));
}

export { convertToJoinRequestsTable };
